import debounce from 'lodash.debounce';
import Breakpoint from '../utilities/Breakpoint';

const header = document.getElementById( 'header' );
const bar = document.querySelector( '.announcementBar-close' );
const navBar = document.querySelector( '.navBar' );

const inertia = 5;
let scrollY = 0;
let prevScrollY = 0;
let ticking = false;
let width = window.innerWidth;

let boundry = 250;
let active = 400;

let headerHeight = 0;

function handleScrollUp() {
	prevScrollY = scrollY;
	scrollY = window.scrollY + inertia;

	if ( scrollY > headerHeight ) {
		document.body.classList.add( 'headerScrolled' );
	}

	if ( scrollY < headerHeight ) {
		document.body.classList.remove( 'headerScrolled' );
	}

	if ( scrollY > boundry ) {
		document.body.classList.add( 'scrolled' );
		document.body.classList.toggle( 'scrollUp', scrollY < prevScrollY );
	}

	if ( scrollY < boundry ) {
		document.body.classList.remove( 'scrolled' );
		document.body.classList.remove( 'scrollUp' );
	}

	if ( scrollY > active ) {
		document.body.classList.add( 'active' );
	}

	if ( scrollY < active ) {
		document.body.classList.remove( 'active' );
	}

	ticking = false;
}

function requestTick() {
	if ( !ticking ) {
		window.requestAnimationFrame( handleScrollUp );
		ticking = true;
	}
}

function setBoundary() {
	if ( Breakpoint.get() === 'desktop' ) {
		boundry = 350;
		active = 500;
	}
}

function setHeaderHeight() {
	header.removeAttribute( 'style' );
	header.setAttribute( 'style', `height:${header.offsetHeight}px` );
	headerHeight = header.offsetHeight;
}

function handleResize() {
	// Prevent resize on vertical scroll.
	if ( width === window.innerWidth ) {
		return;
	}
	width = window.innerWidth;
	setBoundary();
}

function handleBarDismiss() {
	header.removeAttribute( 'style' );
	header.setAttribute( 'style', `height:${navBar.offsetHeight}px` );
}

function initEvents() {
	window.addEventListener( 'scroll', requestTick );
	window.addEventListener( 'resize', debounce( handleResize, 250 ) );
	if ( bar ) {
		bar.addEventListener( 'click', handleBarDismiss );
	}
}

function init() {
	initEvents();
	setBoundary();
	setHeaderHeight();
}

export default {
	init,
};
